import kanbanAPI from 'dashboard/api/kanban';

export default {
  data() {
    return {
      _saveColorTimers: {},
    };
  },
  methods: {
    normalizeHex(v) {
      if (!v) return '#999999';
      let s = String(v).trim();
      if (s[0] !== '#') s = `#${s}`;
      if (s.length === 4) s = `#${s[1]}${s[1]}${s[2]}${s[2]}${s[3]}${s[3]}`;
      return s.slice(0, 7).toLowerCase();
    },
    hexToRgb(h) {
      const s = this.normalizeHex(h).slice(1);
      const r = parseInt(s.slice(0, 2), 16);
      const g = parseInt(s.slice(2, 4), 16);
      const b = parseInt(s.slice(4, 6), 16);
      return [r, g, b];
    },
    contrastTextColor(hex) {
      const toLin = c => {
        const v = c / 255;
        return v <= 0.03928 ? v / 12.92 : Math.pow((v + 0.055) / 1.055, 2.4);
      };
      const [r8, g8, b8] = this.hexToRgb(hex);
      const L = 0.2126 * toLin(r8) + 0.7152 * toLin(g8) + 0.0722 * toLin(b8);
      return L > 0.5 ? '#111111' : '#ffffff';
    },
    headerStyle(col) {
      const hex = this.normalizeHex(col?.color || '#f3f4f6');
      return { backgroundColor: hex };
    },
    titleColor(col) {
      const root = document.documentElement;
      const isDark =
        root.classList.contains('dark') ||
        root.getAttribute('data-theme') === 'dark';
      if (!isDark) return '#ffffff';
      const hex = this.normalizeHex(col?.color || '#f3f4f6');
      return this.contrastTextColor(hex);
    },
    cardsBgStyle(col) {
      try {
        const hex = this.normalizeHex(col?.color || '#ffffff');
        const [r, g, b] = this.hexToRgb(hex);
        const mul = 2.0;
        const clamp = v => Math.max(0, Math.min(0.45, v));
        const aStart = clamp(0.20 * mul);
        const aEnd   = clamp(0.12 * mul);
        const rgba = a => `rgba(${r}, ${g}, ${b}, ${a})`;
        return { background: `linear-gradient(90deg, ${rgba(aStart)} 0%, ${rgba(aEnd)} 100%)` };
      } catch {
        return { background: 'none' };
      }
    },
    onColorInput(col, value) {
      col.color = this.normalizeHex(value);
      this._debouncedSaveColor(col.id, col.color);
    },
    _debouncedSaveColor(id, color) {
      if (!this._saveColorTimers[id]) {
        this._saveColorTimers[id] = this._debounce(async latest => {
          try {
            await kanbanAPI.updateColumn(id, { color: latest });
          } catch (e) {
            this.error = e?.response?.data?.error || e.message || 'Falha ao salvar cor';
          }
        }, 400);
      }
      this._saveColorTimers[id](color);
    },
    _debounce(fn, wait = 300) {
      let t;
      return function (arg) {
        clearTimeout(t);
        t = setTimeout(() => fn(arg), wait);
      };
    },
  },
};
